import { Component, inject, Input } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { ScadenzeArticoliService } from 'src/app/shared/services/scadenze-articoli.service';
import moment from 'moment';
import {
  DxiColumnComponent,
  DxoColumnChooserComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-grid-scadenze-articoli-compact',
  templateUrl: './grid-scadenze-articoli-compact.component.html',
  styleUrls: ['./grid-scadenze-articoli-compact.component.scss'],
  imports: [
    DxDataGridComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoExportComponent,
    DxoColumnChooserComponent,
    DxoEditingComponent,
    DxiColumnComponent,
    DxoTextsComponent,
  ],
})
export class GridScadenzeArticoliCompactComponent {
  private scandenzeS = inject(ScadenzeArticoliService);

  @Input() idArticolo: number;
  dataSource: any;
  columnResizingMode = 'widget';

  constructor() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.scandenzeS.listByArticolo(this.idArticolo))
          .then((response) => {
            const oggi = moment().startOf('day');
            return {
              data: response.filter(
                (x) => !x.eseguito && moment(x.data).isSameOrAfter(oggi, 'day'),
              ),
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
    });
  }
}
